module.exports = __webpack_public_path__ + "7c82d1a5f0b5f6044cce0c38b2ea4733.svg";